module.exports = {"653128100":"岳普湖镇","653128101":"艾西曼镇","653128102":"铁热木镇","653128103":"也克先拜巴扎镇","653128200":"岳普湖乡","653128203":"阿其克乡","653128204":"色也克乡","653128206":"巴依阿瓦提乡","653128207":"阿洪鲁库木乡","653128402":"岳普湖县奶牛场","653128502":"兵团四十二团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653128.json
// module id = 3113
// module chunks = 0